import React from "react"

import Layout from "../layout/Layout"

import { Container, Row, Col, Button } from "react-bootstrap"

import HelmetInject from "../components/HelmetInject"

import RightImageCard from "../layout/parts/RightImageCard"
import LeftImageCard from "../layout/parts/LeftImageCard"

import vaccineLogo from "../images/vaccine.svg"
import companies from "../images/companies.svg"
import graphs from "../images/graphs.svg"
import TitleBoldLarge from "../components/typography/TitleBoldLarge"
import TitleLight from "../components/typography/TitleLight"
import TitleBold from "../components/typography/TitleBold"

import { Link } from "gatsby"

export default function Home() {
  return (
    <>
      <HelmetInject title="covid Vaccine Tracker Home" contentDescription="" />
      <Layout>
        <Container fluid className="background-color-white">
          <Row>
            <Col className="text-center">
              <h1 className="mt-5">
                <TitleBoldLarge>
                  Covid Vaccine Map and data tracker
                </TitleBoldLarge>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <h3 className="mt-5">
                <TitleLight>
                  Get the last News about the Covid Vaccines
                </TitleLight>
              </h3>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3 mb-5">
              <Button size="lg" href="/covid-vaccine-map">
                See the Data
              </Button>
            </Col>
          </Row>
        </Container>
        <Container fluid className="background-color-ghost-white">
          <Container>
            <Row>
              <RightImageCard
                alt="corona news data image"
                src={vaccineLogo}
                className="img-fluid"
                width="358"
                height="358"
                // titleH1="Páginas PWA"
                titleH2={[
                  "Info of Mundial Covid",
                  <span className="orange-red-bolded"> Vaccines</span>,
                ]}
                titleH3="Get the Increasing and Changing information about the improvements of the Vaccine"
              />
              <LeftImageCard
                alt="coronavirus vaccine data image"
                src={companies}
                className="img-fluid"
                width="358"
                height="358"
                // titleH1="Páginas PWA"
                titleH2={[
                  <span className="orange-red-bolded">
                    Companies and Institutions
                  </span>,
                  "  creating Covid Vaccine",
                ]}
                titleH3="Get the name of all these, an his country location "
              />
              <RightImageCard
                alt="covid vaccine data image"
                src={graphs}
                className="img-fluid"
                width="358"
                height="358"
                // titleH1="Páginas PWA"
                titleH2={[
                  "Stadistics about ",
                  <span className="orange-red-bolded">
                    Countries and Companies
                  </span>,
                ]}
                titleH3={[
                  "How many Vaccines are developing in every Country?",
                  <p>Which the most advanced?</p>,
                ]}
              />
            </Row>
            <Row>
              <Col className="text-center mt-5">
                <h1 className="mt-5">
                  <TitleBold>Last Covid publications in our blog</TitleBold>
                </h1>
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <h3 className="mt-5">
                  <Link to="/covid-vaccine-map">
                    Covid Vaccine Map and wordlwide tracker
                  </Link>
                </h3>
                <h3 className="mt-5">
                  <Link to="/covid-vaccine-blog/corona-news">Corona news</Link>
                </h3>
                <h3 className="mt-5">
                  <Link to="/covid-vaccine-blog/corona-vaccine">
                    Corona vaccine
                  </Link>
                </h3>
              </Col>
            </Row>
          </Container>
        </Container>
      </Layout>
    </>
  )
}
